/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { neuronMaturityModulationsGetApiV3NeuronMaturityModulations } from "../../funcs/neuronMaturityModulationsGetApiV3NeuronMaturityModulations.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3NeuronMaturityModulationsRequest$inboundSchema
    .optional(),
};

export const tool$neuronMaturityModulationsGetApiV3NeuronMaturityModulations:
  ToolDefinition<typeof args> = {
    name: "neuron-maturity-modulations-get-api-v3",
    description: ``,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await neuronMaturityModulationsGetApiV3NeuronMaturityModulations(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
